import { Banner } from "@jsq/ds/core";

export type RowError = {
  rowNumber: number;
  name: string;
  code: string;
  reason: string;
};

type ImportErrorsBannerProps = {
  rowErrors: RowError[];
  nodeCount: number;
  preSignedErrorReportUrl?: string | null;
};

export const ImportErrorsBanner = ({
  rowErrors,
  nodeCount,
  preSignedErrorReportUrl,
}: ImportErrorsBannerProps) => {
  if (rowErrors.length === 0) return null;

  return (
    <Banner
      variant="warning"
      title={`${rowErrors.length} of ${nodeCount + rowErrors.length} nodes have errors and are not in the preview`}
      description="Download the error report to identify and fix these nodes"
      buttonProps={
        preSignedErrorReportUrl
          ? {
              children: "Download error report",
              icon: "download",
              variant: "neutral",
              onClick: () =>
                window.open(preSignedErrorReportUrl, "_blank", "noopener,noreferrer"),
            }
          : undefined
      }
    />
  );
};
